var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBronzeClass({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1vw",
    height: "1vw",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.51117 11.7334L8.00005 9.83561L10.4889 11.7334L9.55561 8.65339L12.0445 6.88005H8.99561L8.00005 3.6445L7.0045 6.88005H3.95561L6.4445 8.65339L5.51117 11.7334ZM8.00005 14.2223C7.13931 14.2223 6.33042 14.0589 5.57339 13.7323C4.81635 13.4056 4.15783 12.9623 3.59783 12.4023C3.03783 11.8423 2.5945 11.1838 2.26783 10.4267C1.94117 9.66968 1.77783 8.8608 1.77783 8.00005C1.77783 7.13931 1.94117 6.33042 2.26783 5.57339C2.5945 4.81635 3.03783 4.15783 3.59783 3.59783C4.15783 3.03783 4.81635 2.5945 5.57339 2.26783C6.33042 1.94117 7.13931 1.77783 8.00005 1.77783C8.8608 1.77783 9.66968 1.94117 10.4267 2.26783C11.1838 2.5945 11.8423 3.03783 12.4023 3.59783C12.9623 4.15783 13.4056 4.81635 13.7323 5.57339C14.0589 6.33042 14.2223 7.13931 14.2223 8.00005C14.2223 8.8608 14.0589 9.66968 13.7323 10.4267C13.4056 11.1838 12.9623 11.8423 12.4023 12.4023C11.8423 12.9623 11.1838 13.4056 10.4267 13.7323C9.66968 14.0589 8.8608 14.2223 8.00005 14.2223Z",
    fill: "#6B4A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronzeClass);
export default __webpack_public_path__ + "static/media/bronze_class.67bf7f45e85f767f9e0bfd7e8f8788a1.svg";
export { ForwardRef as ReactComponent };